import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { NucleoResponse } from "../../../shared/response/proyectos/NucleoResponse";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { TecnicoResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { MacroProyectoResponse } from "../../../shared/response/proyectos/MacroProyectoResponse";
import { NucleoPayload } from "../../../shared/services/api/payload/proyectos/NucleoPayload";
import { NucleoSaveService } from "../../services/proyectos/NucleoSaveService";

export class NucleoFormModal extends BaseSmallModalFormComponent<
  NucleoResponse,
  NucleoPayload,
  NucleoSaveService
> {
  private _nombre!:  HTMLInputElement;
  private _region!:  HTMLInputElement;
  private _cultivo!: HTMLSelectElement;
  private _tecnico!: HTMLSelectElement;
  private _macro!:   HTMLSelectElement;
  private _haMax!:   HTMLInputElement;
  private _montoMax!: HTMLInputElement;

  constructor(
    private readonly _cultivos: CultivoResponse[],
    private readonly _tecnicos: TecnicoResponse[],
    private readonly _macros: MacroProyectoResponse[],
    private readonly _onSavedCb: (item: NucleoResponse) => void,
    private readonly _item?: NucleoResponse,
  ) {
    super(new NucleoSaveService());
  }

  protected get title(): string { return this._item ? "Editar núcleo" : "Nuevo núcleo"; }
  protected get saveText(): string { return "Guardar"; }

  protected renderBody(): string {
    const n = this._item;
    return `
      <div class="cl-form-fields">
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-nombre">Nombre <span class="cl-required">*</span></label>
            <input id="nuc-nombre" class="sx-input" type="text" maxlength="150" value="${this._esc(n?.nombre ?? "")}" placeholder="Núcleo Betulia I">
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-region">Región <span class="cl-required">*</span></label>
            <input id="nuc-region" class="sx-input" type="text" maxlength="100" value="${this._esc(n?.region ?? "")}" placeholder="Santander Sur">
          </div>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-cultivo">Cultivo</label>
            <select id="nuc-cultivo" class="sx-input">
              <option value="">— Sin definir —</option>
              ${this._cultivos.map((c) => `<option value="${c.id}" ${n?.cultivoId === c.id ? "selected" : ""}>${this._esc(c.nombre)}</option>`).join("")}
            </select>
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-tecnico">Técnico responsable</label>
            <select id="nuc-tecnico" class="sx-input">
              <option value="">— Sin asignar —</option>
              ${this._tecnicos.map((t) => `<option value="${t.id}" ${n?.tecnicoId === t.id ? "selected" : ""}>${this._esc(t.nombre)}</option>`).join("")}
            </select>
          </div>
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="nuc-macro">Macro-Proyecto</label>
          <select id="nuc-macro" class="sx-input">
            <option value="">— Ninguno —</option>
            ${this._macros.map((m) => `<option value="${m.id}" ${n?.macroProyectoId === m.id ? "selected" : ""}>${this._esc(m.nombre)}</option>`).join("")}
          </select>
        </div>
        <div class="pr-form-row">
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-hamax">Ha máx. por asociación</label>
            <input id="nuc-hamax" class="sx-input sx-input--numeric" type="number" min="0" step="0.1" value="${n?.haMaxAsociacion ?? ""}" placeholder="Opcional">
          </div>
          <div class="cl-form-group">
            <label class="cl-form-label" for="nuc-montomax">Monto máx. referencial (COP)</label>
            <input id="nuc-montomax" class="sx-input sx-input--numeric" type="number" min="0" step="1" value="${n?.montoMaxReferencial ?? ""}" placeholder="Opcional">
            <span class="pr-form-note">Solo informativo — no bloquea la creación de proyectos.</span>
          </div>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._nombre   = el.querySelector<HTMLInputElement>("#nuc-nombre")!;
    this._region   = el.querySelector<HTMLInputElement>("#nuc-region")!;
    this._cultivo  = el.querySelector<HTMLSelectElement>("#nuc-cultivo")!;
    this._tecnico  = el.querySelector<HTMLSelectElement>("#nuc-tecnico")!;
    this._macro    = el.querySelector<HTMLSelectElement>("#nuc-macro")!;
    this._haMax    = el.querySelector<HTMLInputElement>("#nuc-hamax")!;
    this._montoMax = el.querySelector<HTMLInputElement>("#nuc-montomax")!;

    this._nombre.addEventListener("input", () => this._validate());
    this._region.addEventListener("input", () => this._validate());
    this._validate();
  }

  protected buildPayload(): NucleoPayload {
    return {
      id: this._item?.id ?? null,
      nombre: this._nombre.value.trim(),
      region: this._region.value.trim(),
      cultivoId: this._cultivo.value || null,
      tecnicoId: this._tecnico.value || null,
      macroProyectoId: this._macro.value || null,
      haMaxAsociacion: this._haMax.value ? Number(this._haMax.value) : null,
      montoMaxReferencial: this._montoMax.value ? Math.floor(Number(this._montoMax.value)) : null,
    };
  }

  protected override onSaved(item: NucleoResponse): void {
    this._onSavedCb(item);
    this.dispose();
  }

  private _validate(): void {
    const ok = this._nombre.value.trim().length >= 1 && this._region.value.trim().length >= 1;
    this.setSaveDisabled(!ok);
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
